export default function Footer() {
  return (
    <footer className="relative mt-32 border-t border-mgfc-border/80 bg-mgfc-bg/80">
      <div
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, #FF00FF, #00FFFF, #9FFF00, transparent)",
        }}
      />
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:px-6 lg:px-8 md:grid-cols-3 md:items-end">
        <div>
          <img
            src={`${process.env.PUBLIC_URL}/uploads/2018/10/mike-logo-2.png`}
            alt="MGFC"
            className="h-9 w-auto"
            draggable={false}
          />
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.3em] text-mgfc-fg/40">
            // We accept the weirdness.
          </p>
        </div>

        <div className="font-mono text-xs uppercase tracking-[0.25em] text-mgfc-fg/50 md:text-center">
          <div>// 4.5B yrs of earth</div>
          <div>// 100 yrs of you</div>
          <div className="text-mgfc-cyan/80">// ∞ minutes of mike</div>
        </div>

        <div className="font-mono text-xs uppercase tracking-[0.25em] text-mgfc-fg/60 md:text-right">
          <a
            href="mailto:help@mikegordonfanclub.com"
            className="text-mgfc-cyan hover:text-glow-cyan"
          >
            help@mikegordonfanclub.com
          </a>
          <div className="mt-2 text-mgfc-fg/40">
            © {new Date().getFullYear()} MGFC // ALL BOMBS RESERVED
          </div>
        </div>
      </div>
    </footer>
  );
}
